<template>
  <div class="process-bar-container">
    <div class="process-bar" :style="{ width: `${percent}%` }"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startTime: Date.now(),
      currentTime: 0
    }
  },
  props: {
    // 总时长
    totalTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    percent() {
      return this.totalTime
        ? parseInt(
            this.currentTime / this.totalTime >= 1
              ? 1 * 100
              : (this.currentTime / this.totalTime) * 100
          )
        : 0
    },
  },
  methods: {
    startAnimation() {
      requestAnimationFrame(() => {
        this.currentTime = (Date.now() - this.startTime) / 1000
        if (this.currentTime < this.totalTime) {
          this.startAnimation()
        }
      })
    }
  },
  created() {
    this.startAnimation()
  }
}
</script>

<style lang="stylus">
.process-bar-container
  position absolute
  width 85%
  height 7px
  border-radius 4px
  bottom 24px
  left 50%
  transform translateX(-50%)
  background-color rgba(255, 255, 255, 0.2)
  .process-bar
    width 0
    height 100%
    border-radius 4px
    background-color #f9e176
</style>
